import { Spinner } from '@/components/ui/spinner';
import { Progress } from '@/components/ui/progress';

export interface ScriptIndexProgress {
  processed: number;
  total: number;
  percentage: number;
  phase?: string;
}

interface ScriptIndexProgressCardProps {
  message?: string | null;
  progress: ScriptIndexProgress;
}

function ScriptIndexProgressCard({
  message,
  progress,
}: ScriptIndexProgressCardProps) {
  const phaseLabel =
    progress.phase === 'inserting' ? 'Saving test scripts' : 'Indexing test scripts';
  const showDeterminate = progress.total > 0;

  return (
    <div
      className="box-border mb-0 w-full min-w-0 max-w-full rounded-lg border border-solid border-[var(--inv-border)] bg-[var(--inv-surface-muted)] px-6 py-5"
      role="status"
      aria-live="polite"
      aria-busy="true">
      <div className="mb-3 flex items-center gap-3">
        <Spinner compact />
        <h3 className="m-0 text-base font-semibold">{phaseLabel}…</h3>
      </div>

      {message && (
        <p className="mb-3 text-sm text-[var(--inv-text-secondary)]">
          {message}
        </p>
      )}

      {showDeterminate && (
        <>
          <p className="mb-2 text-sm font-medium">
            Files: {progress.processed} / {progress.total}
          </p>
          <Progress value={progress.percentage} className="mb-3" />
        </>
      )}

      <p className="m-0 text-[0.8125rem] text-[var(--inv-text-secondary)]">
        Review code file exclusions below. Start Full Scan will unlock when
        indexing completes.
      </p>
    </div>
  );
}

export default ScriptIndexProgressCard;
